import { redirect } from '@tanstack/react-router'
import { useSessionStore, selectAudience } from '@/lib/session.store'
import { hydrateSessionFromSharedCookie } from '@/lib/session-hydrate'

/**
 * Guard for portal routes. Throws a redirect to /login when there's no
 * client-audience session. Mirrors `@/lib/auth-guard`'s `requireAuth` for the
 * staff shell. Staff and client sessions now share one `session.store`
 * (auth-unification U2), so this checks the decoded `audience` rather than
 * just token presence — a staff token must never unlock the portal.
 */
export async function requirePortalSession(): Promise<{ token: string }> {
  // A client sent here by the shell lands with an empty `localStorage` — the
  // access token is per-origin and only the `cc_refresh` cookie crosses
  // subdomains. Spend it before deciding they are signed out, same as
  // `requireAuth` does for staff.
  if (!useSessionStore.getState().token) {
    await hydrateSessionFromSharedCookie()
  }

  const { token } = useSessionStore.getState()
  if (!token || selectAudience({ token }) !== 'client') {
    throw redirect({ to: '/login' })
  }
  return { token }
}
